import styles from "./Item.module.css";
import { Comma } from "../../../../base/utils";
import { Uniter } from "../../../../helbest";
import { ReactComponent as OutOfStock } from "../../../../assets/svg/out-of-stock.svg";
import { LangLink } from "../../LangLink/LangLink";
import { channelDetails } from "../../../../base/env";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";


function Item({ data }) {
  const { t } = useTranslation();
  const { Login: { channel } } = useSelector((state) => state);
  const precision = channelDetails[channel].precision;
  const savingAmount = (data.price - data.payable_amount).toFixed(precision);
  const currency = channelDetails[channel].currency;

  return (
    <LangLink
      className={`swiper-slide ${styles.ItemContainer}`}
      to={`/product/${data?.id}`}
    >
      <div className={styles.CategorySliderItem}>
        <div className={styles.ImageContainer}>
          <img
            className={styles.ProductImage}
            src={data.image}
            alt={data.id}
          />

          {data.quantityAvailable === 0 && (
            <OutOfStock className={styles.ImageOutOfStock} />
          )}
        </div>

        <div className={styles.Content}>
          <div className={styles.CategorySliderItemTitle}>
            {data.name}
          </div>

          <div className={styles.Price}>
            {data.price !== data.payable_amount && (
              <Uniter
                unit=""
                className={styles.RealPrice}
                showUnit={false}
              >
                {data.price}
              </Uniter>
            )}

            <Uniter isBold unitSize={9}>
              {data.payable_amount}
            </Uniter>
          </div>

          {savingAmount > 0 && (
            <div className={styles.Discount}>
              <span>{t("common.saving")}</span>
              <Uniter className={styles.UnitColor} isBold unitSize={9} >{Comma(savingAmount)}</Uniter>
            </div>
          )}
        </div>
      </div>
    </LangLink>
  );
}

export default Item;